<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Wan Status</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Wan Status</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <!-- <div class="card-header py-3"> -->
              <!-- <h3 class="card-title">Mac: {{ value.ap_wi_mac }}</h3> -->
              <!-- </div> -->
              <div class="card-body">
                <div class="alert alert-light" role="alert">
                  <!-- <strong>Device Uptime</strong> -->

                  {{
                    value.pstatus == 1 || value.sstatus == 1
                      ? "Uptime: " + formattedUptime
                      : "Downtime: " + formattedDowntime
                  }}
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="custom-list">
                      <h4 class="card-common-title mb-4 p-0">Primary WAN</h4>
                      <ul>
                        <!-- <li><strong>ID</strong> {{ value.id }}</li> -->

                        <li>
                          <strong>WAN Status</strong>
                          {{ value.pstatus == 1 ? "Online" : "Offline" }}
                        </li>

                        <li><strong>Connection Type</strong> {{ value.pproto }}</li>

                        <li><strong>IP Address</strong> {{ value.pip }}</li>

                        <li>
                          <strong>Subnet Mask</strong>
                          {{ value.psubnetmask }}
                        </li>

                        <li>
                          <strong>Default Gateway</strong>
                          {{ value?.pgateway === "0" ? "NA" : value?.pgateway }}
                        </li>

                        <li><strong>DNS</strong> {{ value.pdns }}</li>

                        <li><strong>MAC</strong> {{ value.pmac }}</li>

                        <!-- <li><strong>Interface</strong> {{ value.pinterface }}</li> -->
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="value.totalWan === 2">
                    <div class="custom-list">
                      <h4 class="card-common-title mb-4 p-0">Secondary WAN</h4>
                      <ul>
                        <li>
                          <strong>WAN Status</strong>
                          {{ value.sstatus == 1 ? "Online" : "Offline" }}
                        </li>

                        <li>
                          <strong>Connection Type</strong>
                          {{ value.sproto == "0" ? "NA" : value.sproto }}
                        </li>

                        <li>
                          <strong>IP Address</strong>
                          {{ value.sip == "0" ? "NA" : value.sip }}
                        </li>

                        <li>
                          <strong>Subnet Mask</strong>
                          {{ value.ssubnetmask == "0" ? "NA" : value.ssubnetmask }}
                        </li>

                        <li>
                          <strong>Deafult Gateway</strong>
                          {{ value.sgateway == "0" ? "NA" : value.sgateway }}
                        </li>

                        <li>
                          <strong>DNS</strong>
                          {{ value.sdns == "0" ? "NA" : value.sdns }}
                        </li>

                        <li>
                          <strong>MAC</strong>
                          {{ value.smac == "0" ? "NA" : value.smac }}
                        </li>

                        <!-- <li>
                          <strong>Interface</strong>
                          {{ value.sinterface == "0" ? "NA" : value.sinterface }}
                        </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import axios from "axios";
import { Notification } from "element-ui";
import LocalStorage from "@/services/localStorage";
const fileDownload = require("js-file-download");

export default {
  name: "WanStatusShow",
  metaInfo: {
    title: "Wan Status | Dotlines",
  },
  data: () => ({
    value: {
      uptime: "",
    },
    pre: {},
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  computed: {
    formattedUptime() {
      if (
        typeof this.value.uptime === "string" &&
        this.value.uptime &&
        this.value.uptime !== "0"
      ) {
        this.value.uptime = this.value.uptime.trim();

        const uptimeStr = this.value.uptime.split("up")[1].trim();

        const daysMatch = uptimeStr.match(/(\d+)\s+days?/);
        const hoursMinutesMatch = uptimeStr.match(/(\d+):(\d+)/);
        const hoursOnlyMatch = uptimeStr.match(/(\d+)\s+hours?/);
        const minutesMatch = uptimeStr.match(/(\d+)\s+min/);

        const days = daysMatch ? parseInt(daysMatch[1]) : 0;
        const hours = hoursMinutesMatch
          ? parseInt(hoursMinutesMatch[1])
          : hoursOnlyMatch
          ? parseInt(hoursOnlyMatch[1])
          : 0;
        const minutes = hoursMinutesMatch
          ? parseInt(hoursMinutesMatch[2])
          : minutesMatch
          ? parseInt(minutesMatch[1])
          : 0;

        let formattedUptime = "";
        if (days > 0) {
          formattedUptime += `${days} day${days > 1 ? "s" : ""} `;
        }
        if (hours > 0) {
          formattedUptime += `${hours} hour${hours > 1 ? "s" : ""} `;
        }
        if (minutes > 0) {
          formattedUptime += `${minutes} min${minutes > 1 ? "s" : ""}`;
        }

        return formattedUptime.trim() || "0 mins";
      }
      return "0 mins";
    },

    formattedDowntime() {
      if (typeof this.value.updated_at === "string" && this.value.updated_at) {
        this.value.updated_at = this.formatDateTime(this.value.updated_at);
        const lastUpdatedTime = new Date(this.value.updated_at.replace(/-/g, "/"));
        const currentTime = new Date();

        const downtimeMs = currentTime - lastUpdatedTime;
        const downtimeMinutes = Math.floor(downtimeMs / 60000);
        const downtimeHours = Math.floor(downtimeMinutes / 60);
        const downtimeRemainingMinutes = downtimeMinutes % 60;

        let formattedDowntime = "";
        if (downtimeHours > 0) {
          formattedDowntime += `${downtimeHours} hours `;
        }
        if (downtimeRemainingMinutes > 0) {
          formattedDowntime += `${downtimeRemainingMinutes} mins`;
        }
        return formattedDowntime.trim() || "0 mins";
      }
      return "0 mins";
    },
  },
  methods: {
    formatDateTime(dateTimeString) {
      const date = new Date(dateTimeString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/wan_status/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
